import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { HttpService } from '../../core/services/http-service';
import { takeWhile } from 'rxjs';

import { EInfoType } from '../../core/enums/country-info-type.enum';
import { ESvgIcons } from '../../core/enums/svg-icons';

import { SsrHelperService } from '../../core/services/ssr-helper.service';
import { CloudinaryService } from '../../core/services/cloudinary.service';

import { SearchLinkComponent } from '../search-link/search-link.component';

@Component({
    selector: 'app-location-list',
    templateUrl: './location-list.component.html',
    styleUrls: ['./location-list.component.scss'],
    standalone: false
})
export class LocationListComponent implements OnInit, OnChanges {
  @Input({ required: true }) country: string = '';
  @Input() data: any[] = [];
  @Input() isFetching: boolean = false;
  @Input() dataType: EInfoType = EInfoType.REGION;

  public readonly eInfoType = EInfoType;
  public menuOpened: boolean[] = [];
  public currentVisibleItems = 9;
  public fetchingItems: number[] = new Array(9);
  public cityCache: {
    [region: string]: { data: any[]; dataSearch: any[]; search: string };
  } = {};

  public readonly eSvgIcons = ESvgIcons;

  constructor(
    private cloudinaryService: CloudinaryService,
    private httpService: HttpService,
    private cdr: ChangeDetectorRef,
    private ssrHelperService: SsrHelperService,
  ) {}

  ngOnInit(): void {
    this.updateItemsCount();
  }

  public get showMorePlacesCount(): number {
    return Math.max(this.data.length - this.currentVisibleItems, 0);
  }

  public get activeItems(): any[] {
    return this.data.slice(0, this.currentVisibleItems);
  }

  public isLoadingCities(cities: undefined | any[]): boolean {
    return !Array.isArray(cities);
  }

  public isThingsTodo(item: any): boolean {
    return (
      item.thingsToDoLink ||
      item?.things_todo_extra_description ||
      item?.things_todo_short_description ||
      item?.things_todo_long_description
    );
  }

  public getThingsTodoLink(name: string): string {
    return `/things-to-do-in-${name.toLowerCase()}`;
  }

  public openSearchMenu(regionIndex: number): void {
    this.menuOpened[regionIndex] = true;
    this.getCities(regionIndex);
    this.cdr.markForCheck();
  }

  public closeSearchMenu(
    regionIndex: number,
    searchLinkComponent: SearchLinkComponent,
  ): void {
    this.menuOpened[regionIndex] = false;
    searchLinkComponent.clearInputValue();
  }

  public ngOnChanges(): void {
    this.menuOpened = new Array(this.data.length).fill(0).map(() => false);
    this.getCloudImg();
  }

  public getCities(regionIndex: number): void {
    const country: string = this.country || '';
    const region: string = this.data[regionIndex].name.toLowerCase();

    if (!this.cityCache[region]) {
      this.httpService
        .getRegion(country, region)
        .pipe(takeWhile(() => !this.openSearchMenu[regionIndex]))
        .subscribe((res) => {
          this.cityCache[this.data[regionIndex].region_id] = {
            data: res?.topDestinations || res?.region?.top_destinations || [],
            dataSearch:
              res?.topDestinations || res?.region?.top_destinations || [],
            search: '',
          };
          this.cdr.markForCheck();
        });
    }
  }

  public showMore(): void {
    const screenWidth = window.innerWidth;
    this.currentVisibleItems += screenWidth > 1575 ? 9 : 8;
  }

  public preventDefault(e: MouseEvent): void {
    e.preventDefault();
  }

  private updateItemsCount(): void {
    if (!this.ssrHelperService.userAgent) return;
    const screenWidth = window.innerWidth;
    this.currentVisibleItems = screenWidth > 1575 ? 9 : 8;
  }

  private getCloudImg(): void {
    for (let i = 0; i < this.data.length; i++) {
      const place = this.data[i];

      if (place && !place.imageUrl?.includes('cloudinary')) {
        this.data[i].imageUrl = this.cloudinaryService.getCloudImage(
          place.imageUrl,
        );
      }
    }
  }
}
